import { useState, useEffect } from 'react';
import { Modal, Container, Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import MongoRequestHandler from '../../helpers/MongoRequestHandler';

const ImageGalleryModal = ({ show, onClose, onImageSelect, availableFor }) => {
    const [galleryImages, setGalleryImages] = useState([]);
    const mongoRequestHandler = new MongoRequestHandler();

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchImages = async () => {
            try {
                const samples = await mongoRequestHandler.fetchAllSampleImages(availableFor);
                const formattedImages = samples.map(sample => ({
                    id: sample.imageId,
                    src: sample.imageUrl,
                    alt: sample.imageId,
                }));
                setGalleryImages(formattedImages);
            } catch (error) {
                console.error('Failed to fetch sample images:', error);
            }

            setIsLoading(false);
        };

        if (show) {
            fetchImages();
        }
    }, [show]);

    return (
        <Modal show={show} onHide={onClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Select an Image from Gallery</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoading ? <div>Loading...</div> :
                    <Container>
                        <Row>
                            {galleryImages.map((image) => (
                                <Col xs={6} md={4} lg={3} key={image.id} className="mb-3 position-relative">
                                    <div style={{ 
                                        position: 'absolute', 
                                        bottom: '10%', 
                                        left: '10%', 
                                        backgroundColor: 'rgba(0, 0, 0, 0.5)', 
                                        color: 'white', 
                                        padding: '0.15rem 0.5rem', 
                                        borderRadius: '0.25rem',
                                        fontSize: '0.75rem'
                                    }}>
                                        {image.id}
                                    </div>
                                    <img
                                        src={image.src} alt={image.alt} className="img-fluid"
                                        style={{ cursor: 'pointer', borderRadius: '4px' }}
                                        onClick={() => onImageSelect(image)}
                                    />
                                </Col>
                                
                            ))}
                        </Row>
                    </Container>
                }
            </Modal.Body>
            <Modal.Footer>
                <motion.button 
                    type="button"
                    className="button carousel-button"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.8 }}
                    onClick={onClose}
                >
                    Close
                </motion.button>
            </Modal.Footer>
        </Modal>
    );
};

export default ImageGalleryModal;
